import React from 'react';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { ConsumerUser } from '../../account.types';
import { useOrderList } from './use-order-list';
import { OrderList } from './order-list';
import { useOrdersForConsumer, queryMoreOrders } from './use-orders-for-consumer';

type OrderListControllerProps = {
  user: ConsumerUser;
};

export function OrderListController({ user }: OrderListControllerProps): JSX.Element {
  const { dispensary } = useDispensary();
  const { orders, loading, fetchMore, totalCount, hasError, refetch } = useOrdersForConsumer({ dispensary });

  const handleLoadMoreOrders = (): void => {
    queryMoreOrders(fetchMore, orders);
  };

  const { viewableStatuses, showLoadingSpinner, handleViewOrder } = useOrderList({
    loading,
    orders,
    user,
  });

  return (
    <OrderList
      handleLoadMore={handleLoadMoreOrders}
      hasMoreOrders={orders.length < totalCount}
      loading={loading}
      orders={orders}
      viewableStatuses={viewableStatuses}
      showLoadingSpinner={showLoadingSpinner}
      handleViewOrder={handleViewOrder}
      hasError={hasError}
      onRefetch={refetch}
    />
  );
}
